import {
    service,
    model
} from 'eco-cli'
import {
    Question,
    ShareArticle,
    TrainArticle
} from '@/models/Question.js'
const {
    forum
} = service;
const {
    Filter,
    Sort,
    Page
} = model;

// 获取产品列表
export const getQuestionList = ({
        filter = Filter.new(),
        sort = Sort.new(),
        page = Page.new()
    }) =>
    forum.withToken.get('/community/question/myQuestion', {
        ...filter.toServer(),
        ...sort.toServer(),
        ...page.toServer()
    }).then(res => {
        return {
            list: res.records.map((v) => {
                if (v && v.source === 'TECH_SHARE') {
                    return ShareArticle.fromServer(v)
                } else if (v && v.source === 'TRAIN') {
                    return TrainArticle.fromServer(v)
                } else if (v && v.source === 'QUESTION') {
                    return Question.fromServer(v)
                }

            }),
            page: Page.fromServer(res)
        }
    })